import {Injectable} from '@angular/core';
import {isNullOrUndefined} from "util";

/**
 * Created by Rumyantsev Daniil on 24.07.2018.
 */

@Injectable()
export class DateService {

  constructor() {}
  readonly HOUR_TO_MILLIS = 60 * 60 * 1000;

  getMonthNameDate(date: Date, needYear: boolean): string {

    if (date == null) {
      return "";
    }

    const newDate = new Date(date);
    console.log("Date is: ", newDate.toDateString());

    let result = newDate.toLocaleString("ru", {month: "long"});

    if (needYear) {
      result += ' ' + newDate.getFullYear();
    }

    return result;

  }

  getTwoDigitDate(date: Date, needYear: boolean = false, isClearTimeZone?: boolean): string {

    if (needYear) {
      return new Date(date).toLocaleString("ru-RU", {day: "2-digit", month: "2-digit", year: "2-digit"});
    } else if (!isNullOrUndefined(isClearTimeZone) && isClearTimeZone) {
      return new Date(date).toLocaleString("ru-RU", {day: "2-digit", month: "2-digit", timeZone: "+0000"});
    }
    return new Date(date).toLocaleString("ru-RU", {day: "2-digit", month: "2-digit"});
  }

  clearTimeZone(dateToOffset: string): Date {
    let offsetDate = new Date(dateToOffset);
    let date = new Date();
    
    const userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
    offsetDate = new Date(offsetDate.getTime() + userTimezoneOffset);
    return offsetDate;
  }

  getMonthNameDateGenitiveCase(date: Date): string {

    if (date == null) {
      return null;
    }
    const months = [
      'января',
      'февраля',
      'марта',
      'апреля',
      'мая',
      'июня',
      'июля',
      'августа',
      'сентября',
      'октября',
      'ноября',
      'декабря',
    ];
    const newDate = new Date(date);
    return months[newDate.getMonth() - 1];
  }

  getMonthNameDateWhenCase(date: Date): string {

    if (date == null) {
      return null;
    }
    const months = [
      'январе',
      'феврале',
      'марте',
      'апреле',
      'мае',
      'июне',
      'июле',
      'августе',
      'сентябре',
      'октябре',
      'ноябре',
      'декабре',
    ];
    const newDate = new Date(date);

    let number = newDate.getMonth() - 1;
    if(number === -1) {
      return months[11];
    }
    return months[number];
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/date.service.ts